// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 635) return "7.1.33620-PromotionManager.min.js";
	if (chunkId === 831) return "7.1.33620-PromotionQueryService.min.js";
	if (chunkId === 939) return "7.1.33620-PromotionSearchService.min.js";
	// return url for filenames based on template
	return undefined;
};